import {Serializable} from "../../libraries/util/Serializable";

export class KiziUser implements Serializable {
	constructor(
		readonly name: string,
		readonly emailAddress: string,
		readonly avatarUrl: string,
		readonly groups: string[]
	) {
	}
	
	static deserialize(json: any): KiziUser {
		return new KiziUser(
			json.name,
			json.emailAddress,
			json.avatarUrl,
			json.groups ?? []
		);
	}
	
	serialize(): any {
		return {
			name: this.name,
			emailAddress: this.emailAddress,
			avatarUrl: this.avatarUrl,
			groups: this.groups
		};
	}
}
